import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import moment from 'moment';

export class MunicipalityFeesReport extends AbstractReport {

    getCheckOut(value) {

        if (this.same_day_checkout) {

            return moment(value).subtract(1, 'day').format('YYYY-MM-DD');
        }

        return value;
    }
}
AccessorsMutatorsDecorator(
    'abbreviation',
    'reservation_id',
    'reservation_ident',
    'check_in',
    'check_out',
    'amount',
    'guest_name',
    'room_type',
    'invoice_ident',
    'same_day_checkout',
)(MunicipalityFeesReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/municipality-fees-report.model.js